import { raw } from '../api/http'
import type { TokenPair } from '../api/types'
import { stvoriSesiju, type SessionState, type SessionStore } from './store'

/**
 * Sesija OSOBLJA (recepcija, vozač, admin, operater platforme).
 *
 * Gost ima vlastitu instancu istog storea pod drugim ključem (`auth/gost.ts`),
 * pa dvije prijave u istom pregledniku stoje jedna pored druge umjesto da se
 * prepisuju — vidi `store.ts`.
 */

export type { SessionState } from './store'

const KLJUC_REFRESH = 'shuttly.refresh_token'

export const staffSesija: SessionStore = stvoriSesiju(KLJUC_REFRESH)

export const getSession = (): SessionState => staffSesija.getState()
export const subscribe = (slusac: () => void): (() => void) => staffSesija.subscribe(slusac)
export const getAccessToken = (): string | null => staffSesija.getAccessToken()

/**
 * Osvježavanje sesije. Vraća novi access token ili `null` ako sesija više ne
 * vrijedi — tada je i lokalno stanje očišćeno, pa pozivatelj samo treba
 * prikazati prijavu.
 */
export const osvjezi = (): Promise<string | null> => staffSesija.osvjezi()

/** Pokretanje aplikacije: ako refresh token postoji, sesija se podiže iz njega. */
export const obnoviSesiju = (): Promise<void> => staffSesija.obnovi()

export const odjavi = (): Promise<void> => staffSesija.odjavi()

/** `POST /auth/staff/login` — osoblje se prijavljuje subdomenom, emailom i lozinkom. */
export async function prijaviOsoblje(
  subdomena: string,
  email: string,
  lozinka: string,
): Promise<void> {
  const par = await raw<TokenPair>('/auth/staff/login', {
    metoda: 'POST',
    tijelo: { subdomena, email, lozinka },
  })

  staffSesija.primi(par)
}

/**
 * `POST /auth/staff/change-password` — vraća NOVI par tokena, jer se `pwd_change`
 * iz već izdanog tokena ne može povući unatrag (CLAUDE.md §16, odluka 6).
 * Usput gasi sve ostale sesije, pa je stari refresh token bezvrijedan i lokalno.
 */
export async function promijeniLozinku(stara: string, nova: string): Promise<void> {
  const par = await raw<TokenPair>('/auth/staff/change-password', {
    metoda: 'POST',
    tijelo: { stara_lozinka: stara, nova_lozinka: nova },
    token: staffSesija.getAccessToken(),
  })

  staffSesija.primi(par)
}

/** Samo za testove: vraća modul u polazno stanje. */
export const _resetSession = (): void => staffSesija._reset()
